import { PING_CHANNEL_URL } from 'config';

import React, { Component, PropTypes } from 'react';
import { firebase as fb } from 'redux-firebasev3';

import fetchJSON from '../../utils/fetchJSON';
import DumbChannellistitemactions from '../../components/ChannelListItemActions';

@fb()
export default class ChannelListItemActions extends Component {
  static propTypes = {
    firebase: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    lastPingAt: PropTypes.number,
  }

  state = {
    isPinging: false,
  }

  handlePingChannel = () => {
    const { firebase, id } = this.props;

    this.setState({ isPinging: true });
    firebase.auth().currentUser.getToken().then((idToken) => (
      fetchJSON(`${PING_CHANNEL_URL}?channelId=${id}&idToken=${idToken}`)
    )).then(() => {
      this.setState({ isPinging: false });
    }).catch(() => {
      this.setState({ isPinging: false });
      // TODO handle this with an in-UI error, not an alert.
      alert('Error pinging channel.'); // eslint-disable-line no-alert
    });
  }


  render() {
    const { lastPingAt } = this.props;
    const { isPinging } = this.state;

    return (
      <DumbChannellistitemactions
        isPinging={isPinging}
        lastPingAt={lastPingAt}
        pingChannel={this.handlePingChannel}
      />
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/containers/ChannelListItemActions/index.jsx
 **/